import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  FDDialogActions,
  FDDialogContent,
  FDDialogTitle,
  FDImage, FDList, FDListItem, FDListItemText, FDPrimaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import { stepMap } from '../..';


const CaptureQRCode = ({
  changeState,
}) => {
  const { resource } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <>
      <FDDialogTitle value={'Open & Configure the App'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <FDList>
            <FDListItem>
              <FDListItemText primaryText={'1. Open an authenticator app on your phone (like Google Authenticator, Authy, or Duo).'} />
            </FDListItem>
            <FDListItem>
              <FDListItemText primaryText={'2. Click to add a new account.'} />
            </FDListItem>
            <FDListItem>
              <FDListItemText primaryText={'3. Use the option to scan the barcode.'} />
            </FDListItem>
            <FDListItem>
              <FDListItemText primaryText={'4. Enter the code to access your Facet dashboard.'} />
            </FDListItem>
          </FDList>
          <Grid container justify={'center'} alignItems={'center'}>
            <Grid item>
              <FDImage
                src={`data:image/png;base64, ${resource.attr('image')}`}
                data-test={'security-settings-authenticatorApp-register-modal-qrcode'}
                alt={'QR Code'}
              />
            </Grid>
          </Grid>
          <FDTextButton
            label={'I can\'t scan the barcode'}
            fullWidth
            onClick={() => {
              logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Request backup code');
              changeState(stepMap.backupCode);
            }}
            data-test={'security-settings-button-authenticatorApp-register-modal-cant-scan'}
          />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Enter verification code');
            changeState(stepMap.enterVerificationCode);
          }}
        />
      </FDDialogActions>
    </>
  );
};

CaptureQRCode.propTypes = {
  changeState: PropTypes.func.isRequired,
};

export default CaptureQRCode;
